import React, { Fragment } from 'react';
import { object, bool, func, array } from 'prop-types';
import { Row, Col } from 'antd';

import RequestClients from '../../components/request-clients';
import { MeetingNotesForm } from './meeting-notes-form';
import { TaskForm } from './task-form';
import { Task } from './task';

import {
  CreateTaskButton,
  SectionWrapper,
  TaskContainer,
  CreateButton,
  CheckboxS,
  TitleS,
} from './styled-components';


const MeetingNotesModal = ({
  form,
  tasks,
  users,
  request,
  onDeleteTask,
  isLoadingTask,
  isShowContacts,
  onAssignMeClick,
  onCreateTaskForm,
  onUpdateTaskForm,
  participantsOptions,
  onMeetingNoteCreate,
  onParticipantSearch,
  onToggleEditTaskForm,
  onToggleShowContacts,
  isShowCreateTaskForm,
  setParticipantsOptions,
  onToggleCreateTaskForm,
  isSearchingParticipants,
}) => (
  <React.Fragment>
    <Row gutter={20} type="flex">
      <Col span={12}>
        <SectionWrapper>
          <TitleS>Create meeting note</TitleS>
          <RequestClients
            {...{
              onToggleShowContacts,
              isShowContacts,
              request,
            }}
          />
          <MeetingNotesForm
            {...{
              form,
              onAssignMeClick,
              participantsOptions,
              onParticipantSearch,
              setParticipantsOptions,
              isSearchingParticipants,
              showForm: !isShowContacts,
            }}
          />
        </SectionWrapper>
      </Col>
      <Col span={12}>
        <SectionWrapper>
          <TitleS>
            Tasks {tasks.length > 0 && <b>{tasks.length}</b>}
          </TitleS>
          <TaskContainer>
            {!isShowCreateTaskForm && (
              <CreateTaskButton
                onClick={onToggleCreateTaskForm}
              >
                + Create task
              </CreateTaskButton>
            )}
            {isShowCreateTaskForm && (
              <TaskForm
                {...{ users, request }}
                onCancel={onToggleCreateTaskForm}
                isLoading={isLoadingTask}
                onSubmit={onCreateTaskForm}
              />
            )}

            {tasks.map(task => (
              <Fragment key={task._id}>
                {task.isEdit
                  ? (
                    <TaskForm
                      {...{ ...task, users, request }}
                      onCancel={() => onToggleEditTaskForm(task._id)}
                      isLoading={isLoadingTask}
                      onSubmit={onUpdateTaskForm}
                    />
                  )
                  : (<Task
                    key={task._id}
                    {...{
                      onToggleEditTaskForm,
                      onDeleteTask,
                      users,
                      ...task,
                    }}
                  />)
                }
              </Fragment>
            ))}
          </TaskContainer>
        </SectionWrapper>
      </Col>
    </Row>
    <Row gutter={20} style={{ textAlign: 'center', marginTop: '23px' }}>
      <Col span={24}>
        {form.getFieldDecorator('isNotifyParticipants', {
          valuePropName: 'checked',
          initialValue: false,
        })(<CheckboxS>Notify all participants by email</CheckboxS>)}
      </Col>
      <Col span={24}>
        <CreateButton onClick={onMeetingNoteCreate} disabled={isShowCreateTaskForm}>
          Create meeting note
        </CreateButton>
      </Col>
    </Row>
  </React.Fragment>
);

MeetingNotesModal.propTypes = {
  form: object.isRequired,
  tasks: array.isRequired,
  users: array.isRequired,
  request: object.isRequired,
  onDeleteTask: func.isRequired,
  isLoadingTask: bool.isRequired,
  isShowContacts: bool.isRequired,
  onAssignMeClick: func.isRequired,
  onCreateTaskForm: func.isRequired,
  onUpdateTaskForm: func.isRequired,
  onMeetingNoteCreate: func.isRequired,
  onParticipantSearch: func.isRequired,
  onToggleEditTaskForm: func.isRequired,
  onToggleShowContacts: func.isRequired,
  isShowCreateTaskForm: bool.isRequired,
  participantsOptions: object.isRequired,
  onToggleCreateTaskForm: func.isRequired,
  setParticipantsOptions: func.isRequired,
  isSearchingParticipants: bool.isRequired,
};

export { MeetingNotesModal };



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/component.js